import React from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';
import { IUsePricingFunctionHookReturnType } from 'state/menu-options/hooks/types';
import { MenuPricingProvider, useMenuPricingContext } from 'state/menu-options/menu-pricing';
import { useStoreContext } from 'state/store';

import { MainMenuProvider, useMainMenuContext } from '../main-menu';
import { MenuOptionsProvider, useMenuOptionsContext } from '../menu-options';

export type Menu = ReturnType<typeof useMainMenuContext> &
  ReturnType<typeof useMenuOptionsContext> & {
    showBurgersForBreakfast: boolean;
  } & IUsePricingFunctionHookReturnType;

export const useMenuContext = (currentUrl?: string): Menu => {
  const menuCtx = useMainMenuContext();
  const menuOptionsCtx = useMenuOptionsContext();
  const menuPricingCtx = useMenuPricingContext();

  const { isStoreOpenAndAvailable, store } = useStoreContext();
  const showBurgersForBreakfast = isStoreOpenAndAvailable && store?.hasBurgersForBreakfast === true;

  return {
    ...menuCtx,
    ...menuOptionsCtx,
    ...menuPricingCtx,
    showBurgersForBreakfast,
  };
};

export const MenuProvider = ({ children }: IBaseProps) => {
  return (
    <MainMenuProvider>
      <MenuOptionsProvider>
        <MenuPricingProvider>{children}</MenuPricingProvider>
      </MenuOptionsProvider>
    </MainMenuProvider>
  );
};
